import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Tiles } from 'generated/graphql-types';
import { State, tileSetTypeSelectFeatureKey } from './tile-set-type-select.reducer';

export const tileSetSelectFeature = createFeatureSelector<State>(tileSetTypeSelectFeatureKey);

export const selectCallState = createSelector(tileSetSelectFeature, (state) => {
   return state.callState;
});

export const selectTileSets = createSelector(tileSetSelectFeature, (state) => {
   return state.tileSets;
});

export const selectTileSet = (tileId: Tiles) =>
   createSelector(selectTileSets, (tileSets) => {
      return tileSets ? tileSets[tileId] : null;
   });
